import { Component, EventEmitter, Input, Output } from '@angular/core';
import { AppContext } from '@cigna/chcp/shared/util';
import { MatDialog } from '@angular/material/dialog';

import { DialogExplainAccessComponent } from '@cigna/chcp/shared/ui';
import { DialogCignaCollabrativeCareComponent } from '../dialog-cigna-collabrative-care/dialog-cigna-collabrative-care.component';

@Component({
  selector: 'cigna-wam-onboarding-step',
  templateUrl: './wam-onboarding-step.component.html',
  styleUrls: ['./wam-onboarding-step.component.scss'],
})
export class WamOnboardingStepComponent {
  @Input() currentStep = 1;
  @Input() appContext: AppContext;

  @Output() dismiss = new EventEmitter();
  @Output() continueOnboarding = new EventEmitter();
  @Output() completeOnboarding = new EventEmitter();
  @Output() previousOnboarding = new EventEmitter();

  totalSteps = 5;

  constructor(public dialog: MatDialog) {}

  openExplainAccessDialog() {
    this.dialog.open(DialogExplainAccessComponent, {
      autoFocus: false,
      width: '700px',
      data: {
        title:
          this.appContext === 'chcp'
            ? 'CignaforHCP.com Entitlements'
            : 'Provider.Evernorth.com Entitlements',
      },
    });
  }

  openCCCDialog() {
    this.dialog.open(DialogCignaCollabrativeCareComponent, {
      autoFocus: false,
      width: '700px',
    });
  }
}
